module.exports = __webpack_public_path__ + "img/5020242_m.b90ef802.jpg";